<div>
  <td-wb-modal-header iconId="tertiary--contact">
    <td-wb-modal-header-title modalTitle="tdWb.PORTFOLIO_CONTACTS.title">
    </td-wb-modal-header-title>
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button></td-wb-modal-close-button>
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>
  <div class="td-wb-portfolio-contacts">
    <div class="td-wb-portfolio-contacts__container">
      <h3 class="td-wb-portfolio-contacts__header"
      translate="tdWb.PORTFOLIO_CONTACTS.HELP.TECHNICAL_ASSISTANCE"></h3>
      <h4 class="td-wb-portfolio-contacts__sub-header"
      translate="tdWb.PORTFOLIO_CONTACTS.HELP.HELP_DESK"></h4>
      <div class="td-wb-portfolio-contacts__content">
        <span translate="tdWb.PORTFOLIO_CONTACTS.HELP.TELEPHONE_LABEL"></span>
        <span translate="tdWb.PORTFOLIO_CONTACTS.HELP.TELEPHONE"></span>
      </div>
    </div>
    <td-wb-divider></td-wb-divider>
    <div class="td-wb-portfolio-contacts__container">
      <h3 class="td-wb-portfolio-contacts__header"
      translate="tdWb.PORTFOLIO_CONTACTS.inquiries.ACCOUNT_INQUIRIES"></h3>
      <h4 class="td-wb-portfolio-contacts__sub-header"
      translate="tdWb.PORTFOLIO_CONTACTS.inquiries.PORTFOLIO_MANAGER"></h4>
      <div class="td-wb-portfolio-contacts__content">
        <span translate="tdWb.PORTFOLIO_CONTACTS.inquiries.NAME_LABEL"></span>
        @if (showName()) {
          <span [innerText]="contactData.portfolioManagerName"></span>
        }
      </div>
      <div class="td-wb-portfolio-contacts__content">
        <span translate="tdWb.PORTFOLIO_CONTACTS.inquiries.TELEPHONE_LABEL"></span>
        @if (showPhone()) {
          <span [innerText]="contactData.portfolioManagerPhone | tdWbPhone"></span>
        }
      </div>
    </div>
  </div>
</div>
